// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Itc3Q","colMin":"styles_colMin__2Ngei"};